<div class="transaction-host">
  <div class="ext-tx" #extTx (click)="onExternalTransactionsFocus()">
    <hs-external-transactions-panel></hs-external-transactions-panel>
  </div>
  <hs-resize-handle
    [elem2]="cwTx"
    [elem1]="extTx"
    [initialResizeHandleState]="state?.resizeHandleState"
    (resizeFinished)="onResizeFinished($event)"
  ></hs-resize-handle>
  <div class="cw-tx" #cwTx (click)="onClearwaterTransactionsFocus()">
    <hs-clearwater-transactions-panel></hs-clearwater-transactions-panel>
  </div>
</div>
